module.exports = __webpack_public_path__ + "img/icon-rs.8ce1101.svg";